import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.pad-start.js";
import { getTimeInSeconds } from './getTimeInSeconds';
export function addHoursToTime(time, hoursToAdd) {
  var timeInSeconds = getTimeInSeconds(time);
  if (timeInSeconds === null) {
    return null;
  }
  var secondsToAdd = Math.floor(hoursToAdd * 3600);
  var secondsInDay = 24 * 3600;
  var nextTimeInSeconds = (timeInSeconds + secondsToAdd) % secondsInDay;
  var normalisedTimeInSeconds = nextTimeInSeconds < 0 ? nextTimeInSeconds + secondsInDay : nextTimeInSeconds;
  var hours = String(Math.floor(normalisedTimeInSeconds / 3600)).padStart(2, '0');
  var minutes = String(Math.floor(normalisedTimeInSeconds % 3600 / 60)).padStart(2, '0');
  var seconds = String(normalisedTimeInSeconds % 60).padStart(2, '0');
  return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
export default addHoursToTime;